import { apiService } from './api.service';
import { API_ENDPOINTS } from '../config/api';

export interface Medicamento {
  id: string;
  codigo: string;
  nombre: string;
  principioActivo: string;
  concentracion: string;
  formaFarmaceutica: string;
  presentacion: string;
  laboratorio: string;
  categoria: string;
  requiereReceta: boolean;
  controlado: boolean;
  temperatura: string;
  stockMinimo: number;
  stockMaximo: number;
  precio: number;
  iva: number;
  activo: boolean;
  estado?: string;
  createdAt?: string;
  updatedAt?: string;
  // Nuevos campos para carga masiva
  producto?: string;
  nombreComercial?: string;
  unidadMedida?: string;
  registroSanitario?: string;
  atc?: string;
  expediente?: string;
  consecutivo?: string;
  cantidadCum?: string;
  descripcionComercial?: string;
  viaAdministracion?: string;
  unidadDispensacion?: string;
  unidadMinimaDispensacion?: string;
  ium?: string;
  tipo?: string;
  plan?: string;
  // Campos de inventario (Dispensación)
  lote?: string;
  fechaVencimiento?: string;
  stock?: number;
  estadoLote?: string;
}

export interface CreateMedicamentoData {
  codigo: string;
  nombre: string;
  principioActivo: string;
  concentracion: string;
  formaFarmaceutica: string;
  presentacion: string;
  laboratorio: string;
  categoria: string;
  requiereReceta: boolean;
  controlado: boolean;
  temperatura: string;
  stockMinimo: number;
  stockMaximo: number;
  precio: number;
  iva: number;
  // Nuevos campos opcionales
  producto?: string;
  nombreComercial?: string;
  unidadMedida?: string;
  registroSanitario?: string;
  atc?: string;
  expediente?: string;
  consecutivo?: string;
  cantidadCum?: string;
  descripcionComercial?: string;
  viaAdministracion?: string;
  unidadDispensacion?: string;
  unidadMinimaDispensacion?: string;
  ium?: string;
  tipo?: string;
  plan?: string;
}

export interface UpdateMedicamentoData extends Partial<CreateMedicamentoData> { }

class MedicamentosService {
  async getAll(): Promise<Medicamento[]> {
    return apiService.get<Medicamento[]>(API_ENDPOINTS.MEDICAMENTOS);
  }

  async getById(id: string): Promise<Medicamento> {
    return apiService.get<Medicamento>(`${API_ENDPOINTS.MEDICAMENTOS}/${id}`);
  }

  async getStockCritico(): Promise<Medicamento[]> {
    return apiService.get<Medicamento[]>(API_ENDPOINTS.MEDICAMENTOS_STOCK_CRITICO);
  }

  async create(data: any): Promise<Medicamento> {
    return apiService.post<Medicamento>(API_ENDPOINTS.MEDICAMENTOS, data);
  }

  async createMasivo(data: CreateMedicamentoData): Promise<Medicamento> {
    return apiService.post<Medicamento>(API_ENDPOINTS.MEDICAMENTOS_CREATE, data);
  }

  async createOneToOne(data: any): Promise<Medicamento> {
    return apiService.post<Medicamento>(API_ENDPOINTS.MEDICAMENTOS_CREATE_ONE_TO_ONE, data);
  }

  async createProvisional(data: { forma_farmaceutica: string, concentracion: string, princ_activo: string }): Promise<{ id: string }> {
    return apiService.post<{ id: string }>(`${API_ENDPOINTS.MEDICAMENTOS}/createprovisional`, data);
  }

  async update(id: string, data: any): Promise<Medicamento> {
    return apiService.put<Medicamento>(
      `${API_ENDPOINTS.MEDICAMENTOS}/${id}`,
      data
    );
  }

  async delete(id: string): Promise<{ message: string }> {
    return apiService.delete<{ message: string }>(
      `${API_ENDPOINTS.MEDICAMENTOS}/${id}`
    );
  }

  async search(query: string): Promise<Medicamento[]> {
    return apiService.get<Medicamento[]>(
      `${API_ENDPOINTS.MEDICAMENTOS}?search=${encodeURIComponent(query)}`
    );
  }

  async searchBase(query: string): Promise<any[]> {
    return apiService.get<any[]>(
      `${API_ENDPOINTS.MEDICAMENTOS}/base?search=${encodeURIComponent(query)}`
    );
  }

  async validarCums(cums: string[]): Promise<any[]> {
    return apiService.post<any[]>(API_ENDPOINTS.MEDICAMENTOS_VALIDAR_CUMS, { cums });
  }
}

export const medicamentosService = new MedicamentosService();
